import { Step } from 'react-joyride';

export const profileSteps: Step[] = [
  {
    target: '.tour-profile-header',
    title: 'Profile Header',
    content:
      'This is your profile, where you can make changes to your contact details and more.',
    placement: 'left',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '.tour-general-tab',
    title: 'General Tab',
    content:
      'This is your general tab, where you can edit your contact details and more.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
  },
  {
    target: '.tour-industries-tab',
    title: 'Industries Tab',
    content:
      'This is your industries tab, where you can edit the industries you are interested in.',
    placement: 'bottom',
    disableBeacon: true,
    disableScrolling: true,
  },
];
